import { useState } from 'react';

const capacityChartTypes = [
    {
        type: 0,
        name: 'Długość pala',
    },
    {
        type: 1,
        name: 'Obliczeniowa nośność pala na wciskanie',
    },
    {
        type: 2,
        name: 'Minimalna obliczeniowa nośność pala na wciskanie',
    },
    {
        type: 3,
        name: 'Maksymalna obliczeniowa nośność pala na wciskanie',
    },
    {
        type: 4,
        name: 'Obliczeniowa nośność pala na wyciąganie',
    },
    {
        type: 5,
        name: 'Minimalna obliczeniowa nośność pala na wyciąganie',
    },
    {
        type: 6,
        name: 'Maksymalna obliczeniowa nośność pala na wyciąganie',
    },
    {
        type: 7,
        name: 'Siła do próbnego obciążenia',
    }
];

const PileCptService = () => {
    const [settings, setSettings] = useState({
        showVertical: true,
        showHorizontal: true,
        showLegend: true,
        showValues: false,
        showDescription: true,
        showValue: true,
        rotateDescriptionX: false,
    });
    const [capacityType, setCapacityType] = useState(0);
    const [capacityName, setCapacityName] = useState('Długość pala');
    const [chartNames, setChartNames] = useState({
        0: {
            title: 'Rozkład długości pala wzdłuż profili geologicznych',
            axisY: 'Długość pala [m]',
            axisX: 'Profile geologiczne',
            legend: '- długość pala',
        },
        1: {
            title: 'Nośność pionowa pala na wciskanie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        2: {
            title: 'Minimalna nośność pionowa pala na wciskanie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        3: {
            title: 'Maksymalna nośność pionowa pala na wciskanie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        4: {
            title: 'Nośność pionowa pala na wyciąganie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        5: {
            title: 'Minimalna nośność pionowa pala na wyciąganie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        6: {
            title: 'Maksymalna nośność pionowa pala na wyciąganie wg EAP',
            axisY: 'Nośność pala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność pala',
        },
        7: {
            title: 'Siła do próbnego badania pala',
            axisY: 'Siła [kN]',
            axisX: 'Profile geologiczne',
            legend: '- siła do badania próbnego',
        },
    });

    const onChangeChartTitles = (e = {}, type) => {
        if (e.target) {
            const { name, value } = e.target;

            setChartNames((state) => ({
                ...state,
                [type]: {
                    ...state[type],
                    [name]: value,
                },
            }));
        }
    };
    const onToggleChartType = (e) => {
        const currentSelectProject = capacityChartTypes.find(
            (ele) => ele.name === e.target.value,
        );

        if (currentSelectProject) {
            setCapacityType(currentSelectProject.type);
            setCapacityName(currentSelectProject.name);
        }
    };
    const onChangeSettings = (e) => {
        e.preventDefault();
        e.persist();

        const name = e.currentTarget.getAttribute('name');

        setSettings((state) => ({ ...state, [name]: !state[name] }));
    };

    const pileCptCapacity = {
        state: {
            chartNames,
            capacityType,
            capacityName,
            capacityChartTypes,

            settings,
        },
        onChangeChartTitles,
        onToggleChartType,
        onChangeSettings,
    };

    return {
        pileCptCapacity,
    };
};

export default PileCptService;
